import React, {createContext, useContext, useState, ReactNode, useEffect} from 'react';
import useSetParamsURL from '../../../../../lib/useSetParamsURL';
import DialogDetalheAgrotoxico from "./DialogDetalheAgrotoxico";
import {Stack, Typography} from "@mui/material";

interface ModalContextType {
    openModal: (content: string) => void;
    closeModal: () => void
}

const ModalDetalheAgrotoxico = createContext<ModalContextType | undefined>(undefined);

export const ModalDetalheAgrotoxicoProvider: React.FC<{ children: ReactNode }> = ({children}) => {

    const {searchParams, clearSingleParamUrl} = useSetParamsURL();
    const codigo = searchParams.get('detalhe-agrotoxico')

    const [isOpen, setIsOpen] = useState(Boolean(codigo));
    const [itemValue, setItemValue] = useState<string | null>(codigo);

    const openModal = (content: string) => {
        setItemValue(content);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setItemValue(null);
        clearSingleParamUrl("detalhe-agrotoxico")
    };

    useEffect(() => {
        if (codigo) setItemValue(codigo)
    }, [codigo])

    return (
        <ModalDetalheAgrotoxico.Provider value={{openModal, closeModal}}>
            {children}

            {
                (itemValue && isOpen) &&
                <DialogDetalheAgrotoxico
                    open={isOpen}
                    value={itemValue}
                    handleClose={closeModal}
                />
            }
        </ModalDetalheAgrotoxico.Provider>
    );
};

export const DadosTitulosItems = ({
                                      titulo,
                                      valor
                                  }: DadosAgrotoxicoItemsProps) => {
    return (
        <Stack>
            <Typography fontWeight="bold" variant="subtitle2">{titulo}</Typography>
            <Typography variant="subtitle2">{valor}</Typography>
        </Stack>
    )
}

interface DadosAgrotoxicoItemsProps {
    titulo: string,
    valor: string
}


// Hook para usar o contexto
export const useModalDetalheAgrotoxico = (): ModalContextType => {
    const context = useContext(ModalDetalheAgrotoxico);
    if (!context) throw new Error('useModal must be used within a ModalProvider');
    return context;
};